import { Container } from '@moonpig/launchpad-components'
import { TextInput } from '@moonpig/launchpad-forms'
import { colorValue, spacingPx } from '@moonpig/launchpad-theme'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledFormContainer = styled(Container)`
  ${s({
    p: 5,
    pt: 0,
  })}

  flex-shrink: 0;
  width: 100%;
`

export const StyledForm = styled('form')`
  ${s({
    borderRadius: 'borderRadius02',
    border: 1,
    borderColor: 'colorBorder03',
  })}
  overflow: visible;

  &:focus-within {
    box-shadow: none;
    outline: none;
  }
`

export const StyledTextInput = styled(TextInput)`
  &:focus-within,
  > div:focus-within {
    box-shadow: none;
    outline: none;
  }

  [data-testid='search-concierge-modal-input-submit'] {
    ${s({
      borderRadius: 'borderRadius02',
    })}
    right: ${spacingPx(2)};
    top: ${spacingPx(2)};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input {
    ${s({
      bgcolor: 'colorBackground01',
      p: 6,
      pr: 13,
      borderRadius: 'borderRadius02',
      borderColor: 'colorBorder03',
    })}

    overflow: hidden;
    height: 56px;
    min-height: ${spacingPx(12)};
    transition: background-color 150ms ease;
  }

  input:hover {
    ${s({
      bgcolor: 'colorBackground02',
    })}
  }

  input::placeholder {
    color: ${colorValue('colorBlack60')};
  }

  button {
    ${s({
      bgcolor: 'colorInteractionButton',
      mr: 2,
      borderRadius: 'borderRadius02',
      mt: 3,
    })}

    color: ${colorValue('colorTextInverted')};
    padding: 0;
  }

  button svg {
    color: currentcolor;
  }

  button:disabled {
    opacity: 0.45;
  }

  button:hover,
  button:focus,
  button:active,
  button:hover svg,
  button:focus svg,
  button:active svg {
    color: ${colorValue('colorTextInverted')};
  }

  button:not(:disabled):hover {
    ${s({
      bgcolor: 'colorInteractionButtonHover',
    })}
    border-color: ${colorValue('colorBorder03')};
  }
`
